import React, { useState } from 'react';
import {
  Box,
  Stack,
  Flex,
  InputGroup,
  Input,
  InputRightElement,
  Button,
} from '@chakra-ui/react';
import { BiEdit, BiMessageDetail } from 'react-icons/bi';
import { CiSearch } from 'react-icons/ci';
import { CiFilter } from 'react-icons/ci';

import NewRoomSearchDialog from './NewRoomSearchDialog';

const SearchBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box>
      <Stack>
        <Flex py={3} mx={2}>
          <InputGroup>
            <Input
              placeholder="Search Message"
              fontSize={14}
              color="#FFF"
              border="solid 1px #E3E3E3"
              _focus={{ boxShadow: 'none', border: 'solid 1px #E3E3E3' }}
              borderRadius="xl"
            />
            <InputRightElement>
              <CiSearch color="green.500" fontSize={22} />
            </InputRightElement>
          </InputGroup>
          <Button
            border="solid 1px #E3E3E3"
            color="inherit"
            borderRadius="xl"
            px={1}
            mx={2}
            _hover={{ color: 'white', background: 'orange.primary' }}
            cursor="pointer"
          >
            <CiFilter fontSize={25} />
          </Button>
          <Button
            border="solid 1px #E3E3E3"
            color="inherit"
            borderRadius="xl"
            px={1}
            _hover={{ color: 'white', background: 'orange.primary' }}
            cursor="pointer"
            onClick={() => setIsOpen(true)}
          >
            <BiEdit fontSize={20} />
          </Button>
        </Flex>
      </Stack>
      <NewRoomSearchDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </Box>
  );
};

export default SearchBar;
